export default __webpack_public_path__ + "static/MediaContentTwo-eeff4d9b9828c83c9e2354dd0481a67b.webp";